import { getSaleItemPackageDiscountCurrencyInfo } from '@src/domains/sale-items';
import { DetailedSaleItem as SaleItemType } from '@src/core/buyerApiClient';
import useTranslate from '@src/i18n/useTranslate';
import useCurrencyFormat from '@src/hooks/useCurrencyFormat';
import React from 'react';
import SaleItem from '../Summary/SaleSummary/SaleItem';
import {
  PackageDiscountValue,
  PackageOriginalPrice,
  PackagePriceInfo,
  PackagePrices,
  PackageTotalPrice,
} from './styles';

interface SaleItemComponentProps {
  item: SaleItemType;
  showPlaceholderImage?: boolean;
}

export const SalePackageItemDetail: React.FC<SaleItemComponentProps> = ({ item, showPlaceholderImage = false }) => {
  const { i18n } = useTranslate();
  const { formatCurrencyInfo } = useCurrencyFormat();
  const discountCurrencyInfo = getSaleItemPackageDiscountCurrencyInfo(item);

  return (
    <SaleItem showPlaceholderImage={showPlaceholderImage} key={item.id} item={item}>
      <PackagePrices>
        <PackagePriceInfo>
          {i18n('cart_package_previous_price')}
          <PackageOriginalPrice>{formatCurrencyInfo(item.fullPriceCurrencyInfo)}</PackageOriginalPrice>
        </PackagePriceInfo>

        <PackagePriceInfo>
          {i18n('cart_package_discount')}
          <PackageDiscountValue>-{formatCurrencyInfo(discountCurrencyInfo)}</PackageDiscountValue>
        </PackagePriceInfo>

        <PackagePriceInfo>
          {i18n('cart_package_total')}
          <PackageTotalPrice>{formatCurrencyInfo(item.totalPriceCurrencyInfo)}</PackageTotalPrice>
        </PackagePriceInfo>
      </PackagePrices>
    </SaleItem>
  );
};

export default SalePackageItemDetail;
